<template>
  <v-layout class="hierarchy-content" column ref="hierarchy" id="hierarchy">
    <span class="hierarchy-title pl-3 py-2">Hierarchy</span>

    <v-divider class="mb-3" />

    <div style="overflow: auto; height: 100%">
      <v-treeview
        :active.sync="active"
        :items="items"
        :load-children="fetchChildren"
        :open.sync="open"
        activatable
        :open-on-click="!loading"
        id="hierarchy"
        oncontextmenu="return false"
      >
        <template v-slot:prepend="{ item, open }">
          <v-icon color="#B1B6B9" v-if="item.type !== 'node'">
            {{ open ? "mdi-folder-open" : "mdi-folder" }}
          </v-icon>

          <CentralOfficeSVG
            v-else-if="item.layer === 'fc_technical_local_olt'"
          />

          <PrimaryNodeSVG v-else-if="item.layer === 'fc_technical_local_fdp'" />

          <ClosureSplice v-else-if="item.layer === 'fc_closure:splice'" />

          <ClosureDrop v-else-if="item.layer === 'fc_closure:drop'" />

          <BuildingsSVG v-else-if="item.table === 'fc_building'" />
        </template>

        <template v-slot:label="{ item }">
          <div @contextmenu="openMenu(item)">
            {{ item.label }}
          </div>
        </template>
      </v-treeview>
    </div>

    <hierarchy-object-menu
      v-if="menu.isOpen"
      :object-selected="menu.objectSelected"
      :x="menu.x"
      :y="menu.y"
      @close="closeMenu"
      v-on-clickaway="closeMenu"
    />
  </v-layout>
</template>

<script>
import { mapActions } from "vuex";
import HierarchyObjectMenu from "@/components/Network/LeftSidebar/HierarchyObjectMenu";
import { mixin as clickaway } from "vue-clickaway";

import CentralOfficeSVG from "@/assets/network_module/hierarchy-treeview/CO.svg";
import BuildingsSVG from "@/assets/network_module/hierarchy-treeview/building.svg";
import PrimaryNodeSVG from "@/assets/network_module/hierarchy-treeview/PN.svg";
import ClosureSplice from "@/assets/network_module/hierarchy-treeview/closure_splice.svg";
import ClosureDrop from "@/assets/network_module/hierarchy-treeview/closure_drop.svg";

export default {
  name: "Hierarchy",

  components: {
    HierarchyObjectMenu,
    CentralOfficeSVG,
    BuildingsSVG,
    PrimaryNodeSVG,
    ClosureSplice,
    ClosureDrop
  },

  mixins: [clickaway],

  data() {
    return {
      active: [],
      open: [],
      hierarchy: [],
      loading: false,

      menu: {
        isOpen: false,
        objectSelected: null,
        x: 0,
        y: 0
      }
    };
  },

  computed: {
    items() {
      return [
        {
          type: "root",
          id: "root",
          label: "Countries",
          children: this.hierarchy
        }
      ];
    },

    selected() {
      if (!this.active.length) return undefined;

      const id = this.active[0];

      return this.hierarchy.find(node => node.id === id);
    }
  },

  watch: {
    selected(item) {
      this.openMenu(item);
    }
  },

  methods: {
    ...mapActions(["fetchAllCountries", "fetchHierarchyChildrenByType"]),

    async fetchChildren(item) {
      this.loading = true;
      let countries;
      switch (item.type) {
        case "root":
          countries = await this.fetchAllCountries();

          break;
        default:
          if (item.table !== "fc_building") {
            countries = await this.fetchHierarchyChildrenByType({
              type: item.type,
              id: item.id
            });
          }
          break;
      }

      if (
        !!countries &&
        !!countries.data.data &&
        countries.data.data.length > 0
      ) {
        item.children.push(...countries.data.data);
      } else {
        delete item.children;
      }

      this.loading = false;
    },

    /**
     * Open the menu if object type is node
     * @param item
     */
    openMenu(item) {
      if (item.type === "city" || item.type === "node") {
        document.getElementById("hierarchy").oncontextmenu = e => {
          e.preventDefault();
          this.menu.x = e.clientX;
          this.menu.y = e.clientY;
          this.menu.objectSelected = item;
          this.menu.isOpen = true;
          this.$nextTick(
            () => (document.getElementById("hierarchy").oncontextmenu = null)
          );
        };
      }
    },

    /**
     * Closes the menu
     */
    closeMenu() {
      this.menu.objectSelected = null;
      this.menu.isOpen = false;
    }
  }
};
</script>
<style scoped>
.hierarchy-content {
  background: #f5f5f5;
  height: 85%;
  flex: unset;
}

.hierarchy-title {
  text-align: left;
  font: normal normal 600 20px/27px Segoe UI;
  letter-spacing: 0;
  color: #32383d;
  background: #ffffff;
  width: 100%;
}
</style>

<style>
#hierarchy .v-treeview-node__root {
  align-items: start !important;
  min-height: 25px !important;
  width: max-content;
}

#hierarchy .v-treeview-node__label,
#hierarchy .v-treeview-node__prepend {
  text-align: left;
  font: normal normal normal 12px/12px Segoe UI;
  letter-spacing: 0;
  color: #32383d;
  opacity: 1;
  margin: 0 !important;
}

#hierarchy .v-treeview-node__prepend {
  min-width: 22px;
}

#hierarchy .v-application--is-ltr .v-treeview-node__content {
  margin: 0 !important;
}

#hierarchy .v-icon.v-icon:after,
#hierarchy .v-treeview-node__root:before {
  background: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Network/LeftSidebar/Hierarchy.vue